// extracted by mini-css-extract-plugin
module.exports = {"columns":"capital-base--columns--2Th_4","columns2":"capital-base--columns-2--1yWCs","columns3":"capital-base--columns-3--3IC1n"};